import { ISchemaInput, ISIBare, ISIConst, ISIEnum, NestedSchema, RootSchema, TD } from '../union';
import { IsNever, SchemaTypeName } from './core';
import { ISchemaString, SchemaStringFormat } from './string.types';

export * from './string.types';

/**
 * ISSUE
 * - RootSchema<> around the RETURN TYPE with a `ConstVal` or `EnumVal`: not working
 */

/**
 * Property value is a string or array of strings
 */
export function string<EnumVal extends TD<ISchemaString>>(
    schema: RootSchema<ISchemaInput<ISchemaString, ISIEnum<ISchemaString, EnumVal>>>
): ISchemaString<EnumVal>;
export function string<EnumVal extends TD<ISchemaString>>(
    schema: NestedSchema<ISchemaInput<ISchemaString, ISIEnum<ISchemaString, EnumVal>>>
): NestedSchema<ISchemaString<EnumVal>>;
export function string<ConstVal extends TD<ISchemaString>>(
    schema: RootSchema<ISchemaInput<ISchemaString, ISIConst<ISchemaString, ConstVal>>>
): ISchemaString<ConstVal>;
export function string<ConstVal extends TD<ISchemaString>>(
    schema: NestedSchema<ISchemaInput<ISchemaString, ISIConst<ISchemaString, ConstVal>>>
): NestedSchema<ISchemaString<ConstVal>>;
export function string(
    schema: RootSchema<ISchemaInput<ISchemaString, ISIBare<ISchemaString>>>
): RootSchema<ISchemaString>;
export function string(
    schema: NestedSchema<ISchemaInput<ISchemaString, ISIBare<ISchemaString>>>
): NestedSchema<ISchemaString>;
export function string(schema: ISchemaInput<ISchemaString>): ISchemaString {
    const string_schema: ISchemaString = {
        type: SchemaTypeName.string,
        ...schema,
    };

    /**
     * Modifications on custom types
     */

    //  uri_http is a custom type; overwrite .pattern
    if (schema.format === SchemaStringFormat.uri_http && !string_schema.pattern) {
        string_schema.format = SchemaStringFormat.uri;
        string_schema.pattern = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/;
    }

    /**
     * Return
     */
    return string_schema;
}

/**
 * Validation
 */

//  Confirm that the type of `b1` is `string`
const b1 = string({ description: '', $id: 'hello', title: '' }).$id;
// eslint-disable-next-line @typescript-eslint/no-unused-vars
type B1 = IsNever<Exclude<typeof b1, string>>;

//  Confirm that the type of `b2` is `string | undefined`
const b2 = string({ description: '' }).$id;
// eslint-disable-next-line @typescript-eslint/no-unused-vars
type B2 = IsNever<Exclude<typeof b2, string | undefined>>;
